import { map } from 'lodash'
import moment from 'moment'

export default {
  formatDate (date) {
    return moment(date).format('DD/MM')
  },
  doConfirmedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/rollback')
      .then(({data}) => {
        this.$toast.success('Horário(s) definido como agendado com succeso!')
        this.$emit('close', data)
      })
      .catch(() => {
        this.$toast.error('Ocorreu um erro ao definido como agendado.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/rollback/resources/methods.js